import { render, staticRenderFns } from "./NsProductCardBase.vue?vue&type=template&id=743060ab&scoped=true&"
import script from "./NsProductCardBase.vue?vue&type=script&lang=js&"
export * from "./NsProductCardBase.vue?vue&type=script&lang=js&"
import style0 from "./NsProductCardBase.vue?vue&type=style&index=0&id=743060ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743060ab",
  null
  
)

export default component.exports